<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" width="50%">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="form" :model="formData" :label-width="160">

            <FormItem label="终端号" prop="terminalNo" :rules="[rules.required]">
                <Input v-model="formData.terminalNo" placeholder="终端号"></Input>
            </FormItem>
            <FormItem label="SIM卡号" prop="simNo" :rules="[rules.required]">
                <Input v-model="formData.simNo" placeholder="SIM卡号"></Input>
            </FormItem>
            <FormItem label="到期时间" prop="expireTime" :rules="[rules.required]">
                <DatePicker type="datetime" placeholder="到期时间" format="yyyy-MM-dd HH:mm:ss" :value="formData.expireTime" @on-change="pdChange"></DatePicker>
            </FormItem>
        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="primary" @click="handleSubmit">确定</Button>
        </div>
    </Modal>
</template>

<script>
    import iEquip from "@/module/main/api/iEquip";
    import modalHelper from "@/mixins/modalHelper";
    import rules from '@/libs/rules';
    import _don from "@/libs/doson";

    const formModal = {
        id:null,
        terminalNo:null,
        simNo:null,
        expireTime:null,
        equipId:null,
        equipment:null,
        status:0
    };

    export default {
        name: "terminal-edit",
        mixins: [modalHelper],
        components: {
        },
        props:{
            equipId:{
                type:Number,
                required:true
            },
            terminalId:{
                type:Number,
                default:0
            }
        },
        data() {
            return {
                rules,
                title:'设置终端',
                formData: _don.cloneWithModal(formModal),
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);
            },
            async handleSubmit() {
                if (!await this.$refs.form.validate()) return;
                this.formData.equipId = this.equipId
                // 提交
                if (this.terminalId && this.terminalId > 0) {
                    this.formData.equipId = this.formData.equipment.id
                    this.formData.equipment = null
                    iEquip.terminalUpdate(this.formData).then(() => {
                        this.$Message.success('操作成功');
                        this.$emit('on-success', this.formData);
                        this.currValue = false;
                    }).loadingSwitch(this, 'loading');
                } else {
                    iEquip.terminalAdd(this.formData).then(() => {
                        this.$Message.success('操作成功');
                        this.$emit('on-success', this.formData);
                        this.currValue = false;
                    }).loadingSwitch(this, 'loading');
                }
            },
            pdChange(v) {
                this.formData.expireTime = v
            },
        },
        computed: {
        },
        watch:{
            terminalId(v,v1){
                /*if (v != 0) {
                    iEquip.terminalDetail(this.terminalId).then(res => {
                        this.formData = res
                    });
                }*/
            },
            value(val) {
                if (val && this.terminalId > 0) {
                    iEquip.terminalDetail(this.terminalId).then(res => {
                        this.formData = res
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:28px;
    }
</style>
